var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgF6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 391,
    viewBox: "0 0 501 391",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8341 145.246C51.3032 143.454 51.0412 140.81 49.2489 139.341C47.4566 137.872 44.8127 138.134 43.3436 139.926C41.8745 141.718 42.1366 144.362 43.9289 145.831C45.7212 147.3 48.3651 147.038 49.8341 145.246Z",
    fill: "#E6E6FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7836 145.826C72.4223 144.188 72.4223 141.531 70.7836 139.892C69.1449 138.254 66.4881 138.254 64.8494 139.892C63.2107 141.531 63.2107 144.188 64.8494 145.826C66.4881 147.465 69.1449 147.465 70.7836 145.826Z",
    fill: "#E6E6FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1371 144.064C93.6659 141.808 92.2655 139.55 90.0092 139.021C87.7529 138.492 85.4951 139.893 84.9663 142.149C84.4375 144.405 85.8379 146.663 88.0942 147.192C90.3505 147.721 92.6083 146.32 93.1371 144.064Z",
    fill: "#E6E6FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.428 144.042C114.798 141.754 113.242 139.6 110.955 139.231C108.667 138.861 106.513 140.417 106.143 142.704C105.774 144.992 107.329 147.146 109.617 147.516C111.905 147.885 114.059 146.33 114.428 144.042Z",
    fill: "#E6E6FC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8307 100.154C51.2998 98.362 51.0378 95.7181 49.2455 94.2491C47.4531 92.78 44.8093 93.042 43.3402 94.8343C41.8711 96.6266 42.1331 99.2705 43.9254 100.74C45.7178 102.209 48.3616 101.947 49.8307 100.154Z",
    fill: "#E6E6FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8993 98.7422C72.4383 96.4883 71.0482 94.2242 68.7943 93.6852C66.5404 93.1461 64.2763 94.5363 63.7372 96.7902C63.1982 99.0441 64.5884 101.308 66.8423 101.847C69.0962 102.386 71.3603 100.996 71.8993 98.7422Z",
    fill: "#E6E6FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0214 100.992C93.6601 99.3538 93.6601 96.697 92.0214 95.0583C90.3827 93.4196 87.7259 93.4196 86.0872 95.0583C84.4485 96.697 84.4485 99.3538 86.0872 100.992C87.7259 102.631 90.3827 102.631 92.0214 100.992Z",
    fill: "#E6E6FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M111.882 102.17C114.026 101.292 115.053 98.8411 114.174 96.6967C113.295 94.5522 110.845 93.5261 108.7 94.4047C106.556 95.2833 105.53 97.734 106.408 99.8785C107.287 102.023 109.738 103.049 111.882 102.17Z",
    fill: "#E6E6FC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5828 124.246C48.9003 124.246 50.779 122.367 50.779 120.05C50.779 117.732 48.9003 115.854 46.5828 115.854C44.2654 115.854 42.3867 117.732 42.3867 120.05C42.3867 122.367 44.2654 124.246 46.5828 124.246Z",
    fill: "#E6E6FC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8182 124.508C70.1356 124.508 72.0143 122.63 72.0143 120.312C72.0143 117.995 70.1356 116.116 67.8182 116.116C65.5007 116.116 63.6221 117.995 63.6221 120.312C63.6221 122.63 65.5007 124.508 67.8182 124.508Z",
    fill: "#E6E6FC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0565 124.769C91.3739 124.769 93.2526 122.89 93.2526 120.573C93.2526 118.255 91.3739 116.376 89.0565 116.376C86.739 116.376 84.8604 118.255 84.8604 120.573C84.8604 122.89 86.739 124.769 89.0565 124.769Z",
    fill: "#E6E6FC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.292 125.032C112.609 125.032 114.488 123.153 114.488 120.836C114.488 118.518 112.609 116.639 110.292 116.639C107.974 116.639 106.096 118.518 106.096 120.836C106.096 123.153 107.974 125.032 110.292 125.032Z",
    fill: "#E6E6FC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M361.179 19.0934H268.722C245.377 19.0934 226.452 38.0186 226.452 61.3641V107.015C226.452 130.36 245.377 149.285 268.722 149.285H361.179C384.525 149.285 403.45 130.36 403.45 107.015V61.3641C403.45 38.0186 384.525 19.0934 361.179 19.0934Z",
    fill: "#E2E0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M276.359 112.443C297.612 112.443 314.841 95.214 314.841 73.9606C314.841 52.7072 297.612 35.4779 276.359 35.4779C255.105 35.4779 237.876 52.7072 237.876 73.9606C237.876 95.214 255.105 112.443 276.359 112.443Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M289.004 83.0459H264.718V107.332H289.004V83.0459Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M279.311 41.5011H273.775C265.244 41.5011 258.328 48.4173 258.328 56.9489V75.2645C258.328 83.7961 265.244 90.7123 273.775 90.7123H279.311C287.843 90.7123 294.759 83.7961 294.759 75.2645V56.9489C294.759 48.4173 287.843 41.5011 279.311 41.5011Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M251.814 103.602C258.476 109.124 267.029 112.446 276.358 112.446C285.687 112.446 294.241 109.124 300.902 103.602C298.092 101.277 293.83 100.704 288.774 100.644C288.774 100.644 285.17 106.053 276.222 106.053C264.718 106.053 264.17 100.638 264.17 100.638C259.021 100.649 254.764 101.162 251.814 103.602Z",
    fill: "#8A89F5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.299 39.3044C285.299 39.3044 290.226 46.9817 294.184 59.1483L296.036 65.7876C296.036 65.7876 303.305 36.0094 287.701 36.8612L285.302 39.3044H285.299Z",
    fill: "#0E0F29"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.561 39.5891C267.561 39.5891 262.209 48.866 259.174 57.9019L257.049 66.4256C257.049 66.4256 249.788 37.3513 264.743 37.2747L267.561 39.5864V39.5891Z",
    fill: "#0E0F29"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.74 65.4436C285.582 65.4005 286.214 64.3858 286.152 63.1773C286.09 61.9687 285.358 61.0238 284.516 61.0669C283.675 61.11 283.043 62.1246 283.105 63.3332C283.167 64.5418 283.899 65.4866 284.74 65.4436Z",
    fill: "#0E0F29"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M278.873 76.2177C278.873 76.2177 274.4 80.1673 270.407 76.2013",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.313 58.4855C263.767 56.7051 266.92 54.6838 269.535 57.6528C270.144 58.343 269.771 59.7536 269.001 59.666L262.751 59.9097C262.201 60.0111 261.888 59.0086 262.313 58.4882V58.4855Z",
    fill: "#0E0F29"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M268.843 63.3525C268.78 64.5604 268.048 65.508 267.207 65.4642C266.367 65.4204 265.734 64.407 265.797 63.1963C265.86 61.9857 266.591 61.0408 267.432 61.0846C268.273 61.1284 268.906 62.1418 268.843 63.3525Z",
    fill: "#0E0F29"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.941 58.4744C288.519 56.6393 285.408 54.4974 282.737 57.3624C282.118 58.0279 282.463 59.4522 283.233 59.3947L289.478 59.8795C290.029 60.0027 290.357 59.0112 289.941 58.4744Z",
    fill: "#0E0F29"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M258.695 72.2844L258.78 76.5819C258.821 78.5813 259.303 80.4822 260.136 82.1886C261.995 86.0012 265.581 88.6197 269.643 89.4359",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.03 40.7449C294.03 45.5272 285.739 44.6973 276.221 44.6973C266.703 44.6973 259.568 45.5272 259.568 40.7449C259.568 35.9627 267.284 30.4244 276.799 30.4244C286.315 30.4244 294.03 35.9599 294.03 40.7449Z",
    fill: "#0E0F29"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M264.71 87.8171L264.425 103.616",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M288.489 87.8171L288.774 103.616",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M285.003 89.1127C288.353 87.9815 291.229 85.5822 292.831 82.2981C293.666 80.5863 294.157 78.6827 294.2 76.675L294.299 72.2844",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M272.461 65.8671C272.088 68.8169 269.097 72.0982 274.263 72.9857",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M250.511 61.2983C251.96 58.7401 255.433 58.7812 258.265 61.3914L258.128 72.5939C256.561 72.8404 254.679 72.1912 253.014 70.6574C250.182 68.0472 249.059 63.8565 250.508 61.2956L250.511 61.2983Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M258.131 72.5966C256.564 72.8431 254.682 72.194 253.017 70.6601C250.185 68.0499 249.062 63.8593 250.511 61.2983C251.96 58.7401 255.433 58.7812 258.265 61.3914L258.325 64.5084",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.694 61.2983C301.245 58.7401 297.772 58.7812 294.939 61.3914L295.076 72.5939C296.643 72.8404 298.525 72.1912 300.19 70.6574C303.022 68.0472 304.145 63.8565 302.696 61.2956L302.694 61.2983Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M295.077 72.5966C296.643 72.8431 298.525 72.194 300.19 70.6601C303.022 68.0499 304.145 63.8593 302.696 61.2983C301.248 58.7401 297.774 58.7812 294.942 61.3914V65.237",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M261.552 120.282L262.42 122.041C262.669 122.548 263.151 122.898 263.71 122.978L265.652 123.26C267.057 123.465 267.618 125.191 266.602 126.182L265.197 127.552C264.795 127.946 264.608 128.513 264.704 129.069L265.036 131.003C265.277 132.402 263.806 133.471 262.549 132.81L260.812 131.898C260.314 131.635 259.717 131.635 259.218 131.898L257.482 132.81C256.224 133.471 254.754 132.405 254.995 131.003L255.326 129.069C255.422 128.513 255.238 127.946 254.833 127.552L253.428 126.182C252.412 125.191 252.973 123.462 254.378 123.26L256.32 122.978C256.879 122.895 257.361 122.545 257.61 122.041L258.479 120.282C259.108 119.009 260.924 119.009 261.552 120.282Z",
    fill: "#0E0F29"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M278.347 120.282L279.215 122.041C279.465 122.548 279.947 122.898 280.505 122.978L282.447 123.26C283.852 123.465 284.414 125.191 283.398 126.182L281.993 127.552C281.59 127.946 281.404 128.513 281.5 129.069L281.831 131.003C282.072 132.402 280.601 133.471 279.344 132.81L277.608 131.898C277.109 131.635 276.512 131.635 276.013 131.898L274.277 132.81C273.02 133.471 271.549 132.405 271.79 131.003L272.121 129.069C272.217 128.513 272.034 127.946 271.628 127.552L270.223 126.182C269.207 125.191 269.769 123.462 271.174 123.26L273.116 122.978C273.674 122.895 274.156 122.545 274.406 122.041L275.274 120.282C275.904 119.009 277.72 119.009 278.347 120.282Z",
    fill: "#0E0F29"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M295.142 120.282L296.011 122.041C296.26 122.548 296.742 122.898 297.301 122.978L299.243 123.26C300.648 123.465 301.209 125.191 300.193 126.182L298.788 127.552C298.385 127.946 298.199 128.513 298.295 129.069L298.626 131.003C298.867 132.402 297.397 133.471 296.139 132.81L294.403 131.898C293.904 131.635 293.307 131.635 292.809 131.898L291.072 132.81C289.815 133.471 288.344 132.405 288.585 131.003L288.917 129.069C289.013 128.513 288.829 127.946 288.424 127.552L287.019 126.182C286.002 125.191 286.564 123.462 287.969 123.26L289.911 122.978C290.47 122.895 290.952 122.545 291.201 122.041L292.069 120.282C292.699 119.009 294.515 119.009 295.142 120.282Z",
    fill: "#0E0F29"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.883 101.58L264.17 94.2126C264.17 94.2126 281.352 96.108 289.651 93.4128L292.839 104.777C292.839 104.777 273.025 109.25 272.387 109.25C271.749 109.25 260.883 101.58 260.883 101.58Z",
    fill: "#8A89F5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.801 38.9454C262.801 39.5836 279.306 52.6513 289.004 51.7283C296.087 51.0545 299.791 46.8173 301.705 42.969C303.217 39.9287 300.957 36.3571 297.561 36.3133L271.669 35.9983L262.798 38.9454H262.801Z",
    fill: "#0E0F29"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M379.38 68.5813H330.242C327.805 68.5813 325.808 66.5874 325.808 64.1469C325.808 61.7092 327.802 59.7125 330.242 59.7125H379.38C381.817 59.7125 383.814 61.7065 383.814 64.1469C383.814 66.5846 381.82 68.5813 379.38 68.5813Z",
    fill: "#CBC9FF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M362.228 93.706H331.037C328.599 93.706 326.603 91.712 326.603 89.2716C326.603 86.8339 328.597 84.8372 331.037 84.8372H362.228C364.666 84.8372 366.663 86.8311 366.663 89.2716C366.663 91.7093 364.669 93.706 362.228 93.706Z",
    fill: "#CBC9FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M228.065 244.292L273.532 307.837C286.082 321.543 305.219 314.818 306.983 306.289C308.747 297.76 340.363 185.678 340.363 185.678L342.554 184.035C347.054 181.844 349.78 179.472 349.78 179.472C356.578 174.552 364.23 170.452 367.961 164.996L368.476 164.544C368.476 164.544 372.162 159.362 368.939 155.251C368.939 155.251 372.113 149.436 368.947 145.708C368.947 145.708 371.924 140.4 365.572 136.538C365.572 136.538 380.133 128.351 378.139 123.577C375.296 116.771 350.579 132.917 350.579 132.917L335.194 140.302C335.194 140.302 337.747 134.536 337.914 134.133C344.71 117.549 336.216 119.992 335.633 120.658C333.48 123.114 329.903 129.97 325.882 135.591C322.45 140.389 322.935 140.786 319.051 145.703C312.319 155.919 313.116 164.876 314.975 172.09L293.951 222.227L286.676 240.461L267.503 219.644L228.062 244.295L228.065 244.292Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.301 107.034C208.301 107.034 201.368 146.823 224.381 157.009C247.394 167.196 289.977 180.715 256.161 228.491C232.245 262.282 118.569 159.62 118.569 159.62L208.301 107.037V107.034Z",
    fill: "#8A89F5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.509 64.3279C158.517 63.0323 170.456 52.7776 189.07 60.2167C207.681 67.6557 228.676 87.9242 201.091 119.431C201.091 119.431 191.645 80.633 176.019 78.9842C160.396 77.3353 157.509 64.3279 157.509 64.3279Z",
    fill: "#8A89F5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.336 89.7183C117.336 89.7183 102.702 121.463 71.4202 145.246C48.3086 162.816 -51.8367 254.676 115.315 289.19C115.315 289.19 165.375 250.02 167.268 194.325C169.161 138.631 158.862 102.564 158.862 102.564L117.336 89.721V89.7183Z",
    fill: "#8A89F5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0313 236.618L22.1403 276.067C22.1403 276.067 9.81488 296.355 8.33584 299.488C6.85953 302.622 1.52125 320.756 1.52125 320.756C1.52125 320.756 -3.25827 338.094 16.1282 345.002C16.1282 345.002 19.7081 346.667 25.2025 345.366C30.6969 344.065 90.1081 323.597 90.1081 323.597L90.2998 292.649L63.6934 298.951L96.6323 261.764L50.0313 236.618Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.532 173.821C192.532 173.821 186.027 173.98 184.825 169.34C184.121 166.626 183.066 153.92 183.066 153.92L149.837 139.976C149.837 139.976 153.373 151.915 151.434 159.609C149.494 167.303 142.253 169.077 142.253 169.077C142.253 169.077 135.832 203.046 178.752 201.395C178.752 201.395 199.089 194.539 192.529 173.816L192.532 173.821Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.409 169.244C142.409 169.244 123.25 172.838 117.079 172.838C110.908 172.838 92.8527 177.609 72.2912 204.851C50.3793 233.884 41.3763 247.683 42.1624 247.579C56.3804 245.722 84.5947 272.257 85.9861 273.873L84.8905 298.524L78.8647 385.076H258.542L242.656 273.873L259.09 243.197L240.465 179.652C240.465 179.652 230.388 168.655 216.361 170.34C196.186 172.761 192.828 173.399 191.705 173.399C191.705 173.399 200.106 195.089 177.117 196.965C149.624 199.209 142.409 169.244 142.409 169.244Z",
    fill: "#FFD25A"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.988 72.8214C192.716 72.3312 195.578 77.1025 196.068 80.8302L202.16 127.037C203.831 139.707 194.83 151.441 182.157 153.112C174.532 154.24 166.391 152.78 157.791 148.998L143.965 134.829L141.845 73.12L188.991 72.8214H188.988Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.112 116.451C146.112 116.451 140.36 96.0974 166.589 88.1434C185.444 82.4272 181.96 68.4803 167.287 64.3143C152.614 60.151 125.682 64.0787 113.546 98.9076C109.078 111.723 129.958 119.822 129.958 119.822L146.112 116.448V116.451Z",
    fill: "#8A89F5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M491.459 181.663C494.668 181.663 497.269 179.062 497.269 175.854C497.269 172.645 494.668 170.044 491.459 170.044C488.251 170.044 485.65 172.645 485.65 175.854C485.65 179.062 488.251 181.663 491.459 181.663Z",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M154.192 45.1026C156.678 43.0743 157.05 39.4148 155.021 36.9288C152.993 34.4428 149.333 34.0717 146.847 36.1C144.361 38.1282 143.99 41.7878 146.019 44.2738C148.047 46.7598 151.706 47.1308 154.192 45.1026Z",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M173.246 114.726C174.69 114.459 175.55 112.559 175.165 110.482C174.781 108.406 173.298 106.94 171.854 107.207C170.41 107.474 169.55 109.374 169.935 111.451C170.319 113.527 171.802 114.994 173.246 114.726Z",
    fill: "#0E0F29"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M196.863 106.976C197.246 109.053 196.674 110.899 195.581 111.101C194.488 111.304 193.291 109.784 192.905 107.708C192.521 105.632 193.094 103.786 194.187 103.583C195.279 103.38 196.476 104.9 196.863 106.976Z",
    fill: "#0E0F29"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M176.753 126.467C176.753 126.467 180.029 129.792 184.063 127.771",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.184 95.7878C171.048 94.8511 165.058 94.3772 162.124 97.9324C161.442 98.7569 162.664 99.8114 163.872 99.4334L174.099 97.171C175.036 97.0395 175.102 96.0644 174.184 95.7878Z",
    fill: "#0E0F29"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.446 94.3278C195.54 93.0268 191.612 91.7066 188.865 94.4072C188.227 95.0345 188.821 96.1492 189.714 95.9958L197.087 95.5357C197.747 95.5603 198.002 94.7085 197.446 94.3278Z",
    fill: "#0E0F29"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M185.699 95.9548C185.699 95.9548 182.357 100.833 188.325 109.548C191.152 113.676 198.279 115.445 190.966 122.474",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M159.864 149.217C168.465 152.999 175.088 154.3 182.713 153.172C195.383 151.501 204.384 139.767 202.716 127.097L196.624 80.8901C196.134 77.1624 193.272 72.3883 189.544 72.8814",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M142.195 169.639C142.195 169.639 149.434 167.864 151.376 160.17C153.316 152.476 149.089 139.052 149.089 139.052",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M183.006 154.478C183.006 154.478 184.06 167.182 184.764 169.899C185.967 174.539 192.472 174.38 192.472 174.38",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.209 117.976C133.905 113.062 141.251 112.824 147.621 117.448L148.961 138.398C145.685 138.998 141.607 137.96 137.868 135.245C131.497 130.622 128.517 122.89 131.212 117.976H131.209Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M147.621 117.448C141.25 112.824 133.904 113.06 131.209 117.976C128.514 122.89 131.494 130.622 137.865 135.245C141.606 137.96 145.685 139.001 148.958 138.398",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M148.297 130.504L136.714 123.038",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M363.491 138.497L347.758 145.018C346.364 145.596 345.863 147.302 346.704 148.554C347.662 149.981 349.377 151.326 352.343 150.644",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M363.916 146.672L348.183 153.194C346.789 153.772 346.288 155.478 347.129 156.73C348.088 158.157 349.802 159.502 352.768 158.82",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M364.099 156.932L351.089 161.652C349.695 162.23 349.193 163.936 350.034 165.188C350.993 166.615 352.707 167.96 355.674 167.278",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M367.961 165.544C364.231 171 356.575 175.097 349.78 180.019C349.78 180.019 345.893 182.323 341.393 184.514",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M334.787 143.364C334.787 143.364 333.877 145.903 335.022 155.831C335.937 163.75 328.597 169.302 328.597 169.302",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M340.437 185.952C340.437 185.952 309.484 297.853 306.674 306.1C303.187 316.327 285.658 322.353 272.511 306.467L248.408 271.956",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M368.476 164.542C368.476 164.542 372.163 159.359 368.939 155.248C368.939 155.248 372.114 149.433 368.947 145.706C368.947 145.706 371.925 140.397 365.573 136.535C365.573 136.535 380.133 128.349 378.139 123.575C375.296 116.768 350.58 132.915 350.58 132.915L335.195 140.299C335.195 140.299 337.748 134.533 337.915 134.131C344.71 117.546 336.217 119.989 335.633 120.655C333.48 123.112 329.903 129.967 325.882 135.588C322.45 140.387 322.935 140.784 319.051 145.7C312.319 155.917 313.116 164.873 314.976 172.087L282.678 250.116",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7123 274.147L65.9204 297.138",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M285.282 239.806L270.977 222.608",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M240.607 179.455L282.68 235.237L240.966 277.667L227.372 195.267L240.607 179.455Z",
    fill: "#FFD25A"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8848 258.976L111.316 225.561",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M242.264 268.11L237.459 220.685",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M177.087 70.1207C177.087 70.1207 169.752 63.0952 160.883 63.1445",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M152.121 94.262C152.121 94.262 115.955 113.553 120.814 138.327",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M198.911 83.9362C198.911 83.9362 208.733 92.0408 205.419 107.623",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0461 163.224C86.0461 163.224 26.0433 209.009 33.5152 243.651",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M196.118 357.398L103.611 353.679C104.252 305.21 97.772 260.017 79.6372 220.189L172.144 223.909C194.285 260.529 198.405 307.179 196.118 357.398Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M196.118 357.398L103.611 353.679C104.252 305.21 97.772 260.017 79.6372 220.189L172.144 223.909C194.285 260.529 198.405 307.179 196.118 357.398Z",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M188.834 18.6142C192.598 16.4614 198.706 11.4244 200.33 0.912163C200.505 -0.224513 202.094 -0.331333 202.409 0.775214C204.359 7.65553 208.267 15.437 215.172 17.0201C216.178 17.2502 216.52 18.4663 215.78 19.2551C212.861 22.3775 206.621 27.924 205.222 39.8221C205.057 41.219 202.965 41.2245 202.598 39.8659C200.812 33.2266 196.999 24.4893 188.999 21.0382C187.966 20.5917 187.859 19.1729 188.834 18.6115V18.6142Z",
    fill: "#A5A3FF"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M296.499 364.12C300.344 362.123 306.655 357.338 308.706 346.903C308.928 345.774 310.519 345.733 310.788 346.853C312.456 353.808 316.041 361.742 322.878 363.608C323.875 363.879 324.165 365.109 323.395 365.867C320.352 368.867 313.888 374.156 312.007 385.985C311.785 387.374 309.692 387.294 309.383 385.922C307.871 379.217 304.417 370.329 296.564 366.555C295.551 366.067 295.502 364.643 296.499 364.125V364.12Z",
    fill: "#A5A3FF"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M364.669 283.747L336.89 332.49C331.494 341.956 341.903 353.35 352.716 349.814L367.438 344.999C393.935 336.33 403.034 305.722 385.795 283.246C380.24 276.007 368.931 276.275 364.672 283.747H364.669Z",
    fill: "#0E0F29"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M381.3 270.674C367.844 276.193 362.053 285.999 364.168 298.332C369.375 328.724 379.665 384.043 413.653 390.075C447.942 396.158 466.535 335.637 474.07 302.545C476.945 289.91 469.361 279.305 455.935 271.931C434.198 259.989 405.422 260.778 381.298 270.674H381.3Z",
    fill: "#CBC9FF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M409.903 210.734C417.834 210.734 424.264 205.617 424.264 199.305C424.264 192.992 417.834 187.875 409.903 187.875C401.972 187.875 395.543 192.992 395.543 199.305C395.543 205.617 401.972 210.734 409.903 210.734Z",
    fill: "#0E0F29"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M410.207 196.59V181.233",
    stroke: "#0E0F29",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M416.158 179.203C416.695 175.898 414.45 172.783 411.144 172.246C407.838 171.709 404.723 173.954 404.186 177.26C403.65 180.566 405.895 183.681 409.201 184.217C412.506 184.754 415.621 182.509 416.158 179.203Z",
    fill: "#8A89F5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M360.404 251.356C367.016 251.356 372.376 242.445 372.376 231.452C372.376 220.459 367.016 211.548 360.404 211.548C353.792 211.548 348.432 220.459 348.432 231.452C348.432 242.445 353.792 251.356 360.404 251.356Z",
    fill: "#CBC9FF"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M393.817 277.51H433.576C454.108 277.51 470.906 260.712 470.906 240.181V229.734C470.906 209.203 454.108 192.405 433.576 192.405H393.817C373.286 192.405 356.488 209.203 356.488 229.734V240.181C356.488 260.712 373.286 277.51 393.817 277.51Z",
    fill: "#CBC9FF"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M357.369 221.811C356.811 224.366 356.518 227.018 356.518 229.735V240.181C356.518 244.931 357.416 249.477 359.051 253.665",
    stroke: "#0E0F29",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M389.166 261.937H422.226C437.975 261.937 450.862 249.05 450.862 233.301V227.138C450.862 211.389 437.975 198.502 422.226 198.502H389.166C373.417 198.502 360.53 211.389 360.53 227.138V233.301C360.53 249.05 373.417 261.937 389.166 261.937Z",
    fill: "#0E0F29"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M410.944 200.663H391.185C374.976 200.663 362.267 213.873 362.943 230.02",
    stroke: "#36399E",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M421.064 220.233C421.064 225.073 423.206 224.955 425.849 224.955C428.493 224.955 430.634 225.073 430.634 220.233C430.634 215.393 428.493 211.468 425.849 211.468C423.206 211.468 421.064 215.393 421.064 220.233Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M377.474 220.855C377.474 225.695 379.616 224.955 382.259 224.955C384.902 224.955 387.044 225.695 387.044 220.855C387.044 216.015 384.902 212.09 382.259 212.09C379.616 212.09 377.474 216.015 377.474 220.855Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M407.098 230.863H394.628C393.321 230.863 392.376 232.126 392.771 233.369C393.675 236.234 395.863 240.534 400.834 240.534C405.805 240.534 408.021 236.248 408.953 233.383C409.358 232.134 408.413 230.86 407.098 230.86V230.863Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M382.13 275.623C382.13 275.623 386.329 277.541 392.727 277.51C399.125 277.48 435.888 277.524 436.526 277.51C438 277.48 444.45 276.763 449.309 274.01",
    stroke: "#0E0F29",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M465.37 251.356C471.211 251.356 475.945 242.445 475.945 231.452C475.945 220.459 471.211 211.548 465.37 211.548C459.53 211.548 454.795 220.459 454.795 231.452C454.795 242.445 459.53 251.356 465.37 251.356Z",
    fill: "#CBC9FF"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M467.389 250.422C460.777 250.422 455.417 241.512 455.417 230.518C455.417 222.501 458.268 215.59 462.376 212.438",
    stroke: "#0E0F29",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M468.632 241.715C471.294 241.715 473.453 236.563 473.453 230.208C473.453 223.854 471.294 218.702 468.632 218.702C465.97 218.702 463.812 223.854 463.812 230.208C463.812 236.563 465.97 241.715 468.632 241.715Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M408.145 279.571C408.145 279.571 391.938 308.946 409.972 388.212",
    stroke: "#0E0F29",
    strokeWidth: 1.78308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M423.417 317.007C422.322 331.173 412.541 342.493 401.571 342.29C390.602 342.088 382.601 330.439 383.697 316.273C384.792 302.107 394.573 290.787 405.543 290.989C416.512 291.192 424.513 302.841 423.417 317.007Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M469.525 280.819L499.298 328.371C505.08 337.607 495.154 349.423 484.203 346.336L469.295 342.134C442.461 334.572 432.102 304.366 448.397 281.195C453.644 273.731 464.959 273.531 469.522 280.822L469.525 280.819Z",
    fill: "#0E0F29"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.301 299.806L95.8242 291.776C95.8242 291.776 95.5421 324.942 94.8847 324.879C94.2273 324.813 91.3651 323.728 91.3651 323.728L51.2993 337.747L55.301 299.806Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M161.105 308.354L159.64 308.798C161.026 307.678 161.773 306.092 160.486 303.961C159.478 302.296 154.186 301.992 150.601 302.876C126.668 308.773 121.573 305.057 121.573 305.057C119.262 303.835 118.862 300.118 128.662 300.688C142.858 301.512 144.923 292.613 141.825 291.367C139.267 290.337 130.401 290.135 122.283 290.515C111.157 291.036 106.013 290.699 94.7232 291.89L92.4307 323.931C93.6139 324.399 94.8656 324.887 96.2378 325.377C99.6123 326.582 102.529 327.691 106.369 328.636C113.606 330.414 120.045 331.378 132.811 331.66C137.435 331.762 141.497 329.351 143.231 326.834L142.573 326.174C147.194 325.131 152.25 323.175 152.694 318.483L149.481 319.299C153.381 317.864 157.092 316.149 159.158 314.887C162.866 312.619 162.691 309.162 161.1 308.357L161.105 308.354Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M122.757 305.256C136.786 308.99 141.963 305.15 150.604 302.873C154.173 301.934 159.481 302.293 160.489 303.958C162.817 307.809 158.498 309.88 155.775 310.641C155.775 310.641 155.726 310.658 155.636 310.688C145.329 314.175 134.43 315.574 123.573 314.821L117.328 314.388",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M118.837 321.165C118.837 321.165 131.759 323.211 140.552 321.814C146.451 320.877 155.457 317.149 159.166 314.882C162.874 312.614 162.699 309.157 161.108 308.352",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M120.182 326.738C120.182 326.738 130.9 328.316 140.114 326.664C145.192 325.752 152.176 324.03 152.702 318.48",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4336 323.931C93.6168 324.399 94.8685 324.887 96.2408 325.377C99.6152 326.582 102.532 327.692 106.372 328.636C113.609 330.414 120.048 331.378 132.814 331.66C137.438 331.762 141.5 329.351 143.233 326.834",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7261 291.89C106.016 290.699 111.16 291.036 122.286 290.515C130.407 290.135 139.273 290.337 141.828 291.367C144.926 292.616 142.861 301.512 128.665 300.688C118.867 300.118 119.265 303.835 121.576 305.057",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8883 247.853C41.8883 247.853 14.148 287.029 9.79846 296.16C7.94143 300.063 4.33693 309.291 1.84994 319.217C-2.16541 335.251 13.025 349.466 28.8152 344.569C49.5657 338.135 76.7008 330.597 91.8062 323.712",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4995 305.574C21.4995 305.574 77.8321 295.72 94.0441 291.786",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M473.88 120.153C473.549 137.461 459.728 151 443.007 150.397C426.285 149.795 412.998 135.275 413.33 117.968C413.661 100.66 427.482 87.1214 444.204 87.7239C460.925 88.3265 474.212 102.846 473.88 120.153Z",
    fill: "#FFD25A"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M481.84 120.439C481.423 142.296 463.968 159.395 442.85 158.634C421.736 157.872 404.954 139.535 405.373 117.678C405.789 95.8207 423.245 78.7213 444.362 79.4827C465.477 80.2442 482.259 98.5816 481.84 120.439Z",
    stroke: "#0E0F29",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M434.122 121.397L442.41 131.101L456.929 108.787",
    stroke: "#0E0F29",
    strokeWidth: 1.78308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M407.416 313.046C407.145 317.056 403.675 320.307 399.665 320.307C395.655 320.307 392.62 317.056 392.891 313.046C393.163 309.036 396.633 305.785 400.643 305.785C404.653 305.785 407.687 309.036 407.416 313.046Z",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M411.385 323.936L404.929 318.193",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M392.68 18.4691C393.702 16.2916 440.768 17.2228 443.606 68.6581",
    stroke: "#0E0F29",
    strokeWidth: 1.73377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M144.162 175.237C144.162 175.237 151.727 196.979 176.838 196.286C196.992 195.73 192.784 175.845 192.784 175.845",
    stroke: "#0E0F29",
    strokeWidth: 1.59409,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgF6);
export default __webpack_public_path__ + "static/media/f6.abd51685a4792dcc9ef0267494f1a058.svg";
export { ForwardRef as ReactComponent };